import React from 'react';
import { CheckIcon } from 'lucide-react';
export function WhatsIncluded() {
  const items = ['450+ recetas naturales', 'Nutrición para perros', 'Nutrición para gatos', 'Dietas especiales', 'Snacks saludables', 'Primeros auxilios', 'Calculadora nutricional', 'Actualizaciones futuras'];
  return <section className="bg-gray-50 py-10 md:py-14" data-id="element-114">
      <div className="max-w-3xl mx-auto px-5" data-id="element-115">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-ink text-center mb-6" data-id="element-116">
          ¿Qué recibes exactamente?
        </h2>

        <div className="bg-white rounded-2xl border-2 border-forest/15 p-8 md:p-10 shadow-sm" data-id="element-117">
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-118">
            {items.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-119">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-forest/10 flex items-center justify-center" data-id="element-120">
                  <CheckIcon className="w-4 h-4 text-forest" data-id="element-121" />
                </div>
                <span className="text-gray-800" data-id="element-122">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}